import React from 'react'
import { makeStyles, Grid, Chip, Typography } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import pipe from 'lodash/flow'
import omit from 'lodash/omit'
import map from 'lodash/fp/map'
import filter from 'lodash/fp/filter'
import get from 'lodash/fp/get'
import TRANSLATE from 'utils/constants'

const useStyles = makeStyles({
   searchFiltersContainer: {
      display: 'flex',
      flexDirection: 'column',
      marginLeft: 50,
      paddingLeft: 25,
      borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
      height: '100%'
   },
   chipsContainer: {
      display: 'flex'
   },
   chipDeleteIcon: {
      color: '#3264DC',
      width: 12,
      height: 12,
      margin: '0 8px 0'
   },
   searchItem: {
      marginRight: 10,
      backgroundColor: 'rgb(240, 244, 253)',
      color: '#3264DC',
      '&:hover': {
         color: 'rgb(147, 151, 178)',
         backgroundColor: 'rgb(230, 232, 239)',
         '& .chipDeleteIcon': {
            color: 'rgb(147, 151, 178)'
         }
      }
   },
   titleContainer: {
      marginBottom: 5
   },
   title: {
      fontSize: 10,
      color: '#8A8FAB'
   }
})

const getObjectEntries = Object.entries
const isFilterActive = ([_, value]) => Boolean(value)
export const omitMetadata = o =>
   omit(o, ['order', 'page', 'size', 'columnOrder'])

export const buildFiltersDescriptors =
   (options = []) =>
   filters => {
      const findOption = value => options.find(option => option.value === value)
      const findFilterLabel = pipe(findOption, get('label'))
      const toFilterObject = ([filterName, value]) => ({
         filterName,
         label: findFilterLabel(value) || value
      })
      const extractFilterDescriptor = pipe(
         getObjectEntries,
         filter(isFilterActive),
         map(toFilterObject)
      )
      return extractFilterDescriptor(filters)
   }

const SearchFilters = ({ searchFilters, onRemoveFilter }) => {
   const classes = useStyles()

   return (
      <Grid className={classes.searchFiltersContainer}>
         <Grid className={classes.titleContainer}>
            <Typography className={classes.title}>
               {TRANSLATE.LABELS.FILTERED_BY}
            </Typography>
         </Grid>
         <Grid className={classes.chipsContainer}>
            {searchFilters.map(filter => (
               <Chip
                  key={filter.filterName}
                  label={filter.label !== true ? filter.label : 'Si'}
                  classes={{ root: classes.searchItem }}
                  onDelete={() => onRemoveFilter(filter)}
                  deleteIcon={<Close className={classes.chipDeleteIcon} />}
               />
            ))}
         </Grid>
      </Grid>
   )
}

export default SearchFilters
